module.exports = __webpack_public_path__ + "static/img/reservationQRCode.36470173.png";